module.exports = __webpack_public_path__ + "static/media/024.78af4e9d.jpg";